import { connect } from "react-redux";
import { InAppTemplate } from "../../../shared/templates/inapp";

import InAppContent from "../../../views/app/productCategories/InAppContent";
import { appActions } from "../../../redux/actions/in-app";

import "../index.scss";
import { ProductCategoriesPageProps } from "../../../types/app/categoriesTypes";




const ProductCategoriesManagement = (pageProps: ProductCategoriesPageProps | any) => {
    return (
        <InAppTemplate
            pageHeadingTitle="Product Categories Management"
            childComponent={<InAppContent pageProps={pageProps} />}
        />
    );
};

const mapDispatchToProps = {
    getProductCategoriesAction: appActions.GetStoreCategories,
    deleteProductCategoryAction: appActions.DeleteStoreCategory,
    updateProductCategoryAction: appActions.UpdateStoreCategory,
    createProductCategoryAction: appActions.CreateStoreCategory,
    getImageGalleryAction: appActions.GetImageGallery,
};

const mapStateToProps = (state: any) => ({
    getProductCategoriesRequest: state.allInAppReducers.getStoreCategoriesReducer,
    deleteProductCategoryRequest: state.allInAppReducers.deleteStoreCategoryReducer,
    updateProductCategoryRequest: state.allInAppReducers.updateStoreCategoryReducer,
    createProductCategoryRequest: state.allInAppReducers.createStoreCategoryReducer,
    getImageGalleryRequest: state.allInAppReducers.getImageGalleryReducer,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductCategoriesManagement);
